import { connect } from 'react-redux';
import { get } from 'lodash';
import Route from './route.component';

const mapStateToProps = (state: Object) => ({
    activeView: get(state, 'router.currentView')
});

export default connect(
    mapStateToProps
)(Route);
